const features = [
  {
    icon: 'ri-shield-check-line',
    title: '品质保证',
    desc: '精选优质原料，严格品控流程，每一颗糖果都安全美味',
  },
  {
    icon: 'ri-truck-line',
    title: '快速配送',
    desc: '全国多仓发货，下单即享高效配送，甜蜜无需久等',
  },
  {
    icon: 'ri-price-tag-3-line',
    title: '价格实惠',
    desc: '厂家直供，没有中间环节，用更实惠的价格享受好糖果',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '贴心服务',
    desc: '7×24小时在线客服，任何问题随时解答，购物无忧',
  },
];

export default function FeatureHighlights() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feat) => (
            <div key={feat.title} className="text-center">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-full bg-primary-100 flex items-center justify-center">
                <i className={`${feat.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-800 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}